<script setup lang="ts">
import { computed, inject } from "vue";
import { Divider } from "~/components/clarity-ui/Divider";
import useNavigationTracking, {
  NAVIGATION_FOOTER,
} from "~/composables/tracking/useNavigationTracking";
import FooterImprint from "./footer/FooterImprint.vue";
import FooterGrid from "./footer/FooterGrid.vue";
import { filterNodesByType, mapNodes, getId } from "~/utils/helper/magnolia";

const pageFooter = inject("pageFooter", "");

useNavigationTracking(NAVIGATION_FOOTER);

const rows = computed(() => filterNodesByType(mapNodes(pageFooter.value), "footer:row"));
const imprint = computed(
  () => filterNodesByType(mapNodes(pageFooter.value), "footer:imprint")?.[0],
);
</script>

<template>
  <footer class="z-10 w-full">
    <div class="mt-4 rounded-t-2xl bg-light-grey text-sm">
      <div class="container py-8">
        <template v-for="row in rows" :key="getId(row)">
          <FooterGrid :row="row" />
          <Divider class="my-8" color="dark" />
        </template>
        <FooterImprint v-if="imprint" :imprint="imprint" />
      </div>
    </div>
  </footer>
</template>
